import { useState } from 'react';
import { useMutation, useQueries } from '@tanstack/react-query';
import { api } from '../api/cliente';
import { TituloDaPagina } from '../shell/TituloDaPagina';
import './codexImagens.css';

type Status = 'PENDENTE' | 'EXECUTANDO' | 'CONCLUIDO' | 'ERRO';
type Job = { id: number; status: Status; imagemUrl?: string; erro?: string; promptFinal?: string };

export function CodexImagens() {
  const [prompt, setPrompt] = useState('');
  const [estilo, setEstilo] = useState('concept art de videogame');
  const [tamanho, setTamanho] = useState('1024x1024');
  const [qualidade, setQualidade] = useState('medium');
  const [quantidade, setQuantidade] = useState(1);
  const [jobIds, setJobIds] = useState<number[]>([]);
  const gerar = useMutation({
    mutationFn: () => api<Job[]>('/api/codex/imagens', {
      method: 'POST',
      body: JSON.stringify({ prompt, estilo, tamanho, qualidade, quantidade, projeto: 'Mistik Island' }),
    }),
    onSuccess: jobs => setJobIds(jobs.map(job => job.id)),
  });
  const consultas = useQueries({ queries: jobIds.map(id => ({
    queryKey: ['codex-imagem', id],
    queryFn: () => api<Job>(`/api/codex/imagens/${id}`),
    refetchInterval: (query: { state: { data?: Job } }) => {
      const status = query.state.data?.status;
      return status === 'CONCLUIDO' || status === 'ERRO' ? false : 2000;
    },
  })) });
  const jobs = consultas.map(consulta => consulta.data).filter((job): job is Job => Boolean(job));
  const concluidas = jobs.filter(job => job.status === 'CONCLUIDO').length;

  return <div className="codex-pagina">
    <TituloDaPagina>Descreva imagens e deixe o Codex executar o harness do estúdio.</TituloDaPagina>
    <form className="codex-form" onSubmit={e => { e.preventDefault(); if (prompt.trim()) gerar.mutate(); }}>
      <label>O que deve ser criado?<textarea rows={6} maxLength={12000} value={prompt} onChange={e => setPrompt(e.target.value)} placeholder="Ex.: uma criatura anfíbia gigante nos pântanos de Mistik Island, corpo inteiro, iluminação dramática..." /></label>
      <div className="codex-linha">
        <label>Estilo<select value={estilo} onChange={e => setEstilo(e.target.value)}><option>concept art de videogame</option><option>realista</option><option>pintura fantástica</option><option>pixel art</option><option>ilustração de livro</option></select></label>
        <label>Formato<select value={tamanho} onChange={e => setTamanho(e.target.value)}><option value="1024x1024">Quadrado</option><option value="1536x1024">Paisagem</option><option value="1024x1536">Retrato</option></select></label>
        <label>Qualidade<select value={qualidade} onChange={e => setQualidade(e.target.value)}><option value="low">Baixa</option><option value="medium">Média</option><option value="high">Alta</option></select></label>
        <label>Quantidade<input type="number" min={1} max={20} value={quantidade} onChange={e => setQuantidade(Math.max(1, Math.min(20, Number(e.target.value) || 1)))} /></label>
      </div>
      {gerar.error && <p className="codex-erro">{gerar.error instanceof Error ? gerar.error.message : 'Falha ao criar o lote.'}</p>}
      <button className="codex-gerar" disabled={!prompt.trim() || gerar.isPending}>{gerar.isPending ? 'Enviando ao Codex...' : 'Gerar com Codex'}</button>
    </form>
    {jobIds.length > 0 && <section className="codex-resultado">
      <div className="codex-status">{concluidas} de {jobIds.length} imagens prontas</div>
      <div className="codex-galeria">{jobs.map((job, index) => <article key={job.id} className="codex-card">
        <div className="codex-status">Imagem {index + 1}: {job.status === 'CONCLUIDO' ? 'pronta' : job.status === 'ERRO' ? 'falhou' : `${job.status.toLowerCase()}...`}</div>
        {job.imagemUrl && <img src={job.imagemUrl} alt={job.promptFinal || prompt} />}
        {job.erro && <p className="codex-erro">{job.erro}</p>}
      </article>)}</div>
    </section>}
  </div>;
}
